import { AxiosInstancePlus } from '@tencent/oneid-request';
import type { IResponseType } from 'common/constants/Types';
import { http } from 'common/http';

/**
 * 角色通用配置
 */
export interface IRolesGeneralConfig {
  service_code_role_belong: Record<string, number>;
  role_belong_admin_name: Record<string, string>;
  service_code_role_id: Record<string, string>;
  /**
   * 是否允许该类型管理员创建根角色，只是配置项，实际能否创建还需要前端根据当前登录人加入的角色是否在改配置内
   * */
  enable_create_role_role_belongs: Array<number>;
  /**
   * 是否允许该类型管理员编辑角色，且只能编辑管理范围
   */
  enable_edit_manage_scope_role_ids: Array<string>;
}

class RolesApi {
  public axiosInstance: AxiosInstancePlus = http;

  /** 获取用户加入的角色列表 */
  async getJoinRoles() {
    const res: IResponseType = await this.axiosInstance.get('/admin/v3/roles/join', {
      skipShowError: true,
    });
    if (!res || res.errCode) return [];

    return res as { role_id: string }[];
  }

  /**
   * 获取角色通用配置
   */
  getRolesGeneralConfig(): Promise<IResponseType<IRolesGeneralConfig>> {
    return this.axiosInstance.get('/admin/v3/roles/general_config');
  }
}

export default new RolesApi();
